'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Input = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\t\t\t\theight: 85px;\n\t\t\t'], ['\n\t\t\t\theight: 85px;\n\t\t\t']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t\t\t\theight: 73px;\n\t\t\t'], ['\n\t\t\t\theight: 73px;\n\t\t\t']),
    _templateObject3 = _taggedTemplateLiteral(['\n\t\t\t\theight: 59px;\n\t\t\t'], ['\n\t\t\t\theight: 59px;\n\t\t\t']),
    _templateObject4 = _taggedTemplateLiteral(['\n\t\t\t\theight: 47px;\n\t\t\t'], ['\n\t\t\t\theight: 47px;\n\t\t\t']),
    _templateObject5 = _taggedTemplateLiteral(['\n\t\t\t\theight: 65px;\n\t\t\t'], ['\n\t\t\t\theight: 65px;\n\t\t\t']),
    _templateObject6 = _taggedTemplateLiteral(['\n\t\t\t\theight: 56px;\n\t\t\t'], ['\n\t\t\t\theight: 56px;\n\t\t\t']),
    _templateObject7 = _taggedTemplateLiteral(['\n\t\t\t\theight: 52px;\n\t\t\t'], ['\n\t\t\t\theight: 52px;\n\t\t\t']),
    _templateObject8 = _taggedTemplateLiteral(['\n\tborder-color: #72C0B9;\n'], ['\n\tborder-color: #72C0B9;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n\tborder-color: ', ';\n'], ['\n\tborder-color: ', ';\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n\tborder-color: #ddd;\n\n\t> input {\n\t\tbackground-color: ', ';\n\t\tpadding: 5px 0px 5px 5px;\n\t}\n'], ['\n\tborder-color: #ddd;\n\n\t> input {\n\t\tbackground-color: ', ';\n\t\tpadding: 5px 0px 5px 5px;\n\t}\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n\tborder: 2px solid #ddd;\n\tborder-radius: 4px;\n\n\t> input {\n\t\tpadding: 8px;\n\t}\n'], ['\n\tborder: 2px solid #ddd;\n\tborder-radius: 4px;\n\n\t> input {\n\t\tpadding: 8px;\n\t}\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n    display: flex;\n\tflex-direction: column;\n\tfont-family: ', ';\n\n\t', '\n\n\t> .label {\n\t\theight: 16px;\n\t\tmargin-bottom: 10px;\n\t\tfont-size: 14px;\n\t}\n\n\t> .error {\n\t\theight: 16px;\n\t\tmargin-top: 5px;\n\t\tfont-size: 14px;\n\t\tcolor: ', ';\n\t}\n}\n'], ['\n    display: flex;\n\tflex-direction: column;\n\tfont-family: ', ';\n\n\t', '\n\n\t> .label {\n\t\theight: 16px;\n\t\tmargin-bottom: 10px;\n\t\tfont-size: 14px;\n\t}\n\n\t> .error {\n\t\theight: 16px;\n\t\tmargin-top: 5px;\n\t\tfont-size: 14px;\n\t\tcolor: ', ';\n\t}\n}\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 2px solid #ddd;\n\n\t> input {\n\t\tflex-grow: 1;\n\t\toutline: none;\n\t\tborder: none;\n\t\tfont-size: 16px;\n\t\tpadding-bottom: 5px;\n\t}\n\n\t', '\n\t', '\n\t', '\n\t', '\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 2px solid #ddd;\n\n\t> input {\n\t\tflex-grow: 1;\n\t\toutline: none;\n\t\tborder: none;\n\t\tfont-size: 16px;\n\t\tpadding-bottom: 5px;\n\t}\n\n\t', '\n\t', '\n\t', '\n\t', '\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\tpadding: 0 2px 0 10px;\n'], ['\n\tdisplay: flex;\n\tpadding: 0 2px 0 10px;\n']),
    _templateObject15 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\tpadding: 0 10px 0 2px;\n'], ['\n\tdisplay: flex;\n\tpadding: 0 10px 0 2px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getHeight = function getHeight(_ref) {
	var isDisabled = _ref.isDisabled,
	    isBox = _ref.isBox,
	    hasValidator = _ref.hasValidator,
	    hasLabel = _ref.hasLabel;

	if (hasValidator && hasLabel) {
		if (isBox) {
			return (0, _styledComponents.css)(_templateObject);
		} else {
			return (0, _styledComponents.css)(_templateObject2);
		}
	} else if (hasValidator) {
		if (isBox) {
			return (0, _styledComponents.css)(_templateObject3);
		} else {
			return (0, _styledComponents.css)(_templateObject4);
		}
	} else if (hasLabel) {
		if (isBox) {
			return (0, _styledComponents.css)(_templateObject5);
		} else if (isDisabled) {
			return (0, _styledComponents.css)(_templateObject6);
		} else {
			return (0, _styledComponents.css)(_templateObject7);
		}
	}
};

var updatedMixin = (0, _styledComponents.css)(_templateObject8);

var errorMixin = (0, _styledComponents.css)(_templateObject9, _globals2.default.colors.danger);

var disabledMixin = (0, _styledComponents.css)(_templateObject10, _globals2.default.colors.cloud);

var boxMixin = (0, _styledComponents.css)(_templateObject11);

var StyledInput = _styledComponents2.default.div(_templateObject12, _globals2.default.fonts.regular, function (props) {
	return getHeight(props);
}, _globals2.default.colors.danger);

var StyledInputWrapper = _styledComponents2.default.div(_templateObject13, function (props) {
	return props.box ? boxMixin : null;
}, function (props) {
	return props.updated ? updatedMixin : null;
}, function (props) {
	return props.error ? errorMixin : null;
}, function (props) {
	return props.disabled ? disabledMixin : null;
});

var StyledLeftIcon = _styledComponents2.default.span(_templateObject14);

var StyledRightIcon = _styledComponents2.default.span(_templateObject15);

var Input = function (_Component) {
	_inherits(Input, _Component);

	function Input(props) {
		_classCallCheck(this, Input);

		var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

		_this.state = {
			showError: false
		};

		_this.onFocus = _this.onFocus.bind(_this);
		_this.onBlur = _this.onBlur.bind(_this);
		_this.onChange = _this.onChange.bind(_this);
		return _this;
	}

	_createClass(Input, [{
		key: 'getError',
		value: function getError(value) {
			var validator = this.props.validator;


			if (!validator) return null;

			return validator(value);
		}
	}, {
		key: 'onFocus',
		value: function onFocus() {
			var onFocus = this.props.onFocus;


			onFocus();
		}
	}, {
		key: 'onBlur',
		value: function onBlur() {
			var _props = this.props,
			    value = _props.value,
			    onBlur = _props.onBlur;


			if (this.getError(value)) {
				this.setState({ showError: true });
			}

			onBlur();
		}
	}, {
		key: 'onChange',
		value: function onChange(e) {
			var onChange = this.props.onChange;


			onChange(e);

			if (!this.getError(e.currentTarget.value)) {
				this.setState({ showError: false });
			}
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit() {
			var _props2 = this.props,
			    onSubmit = _props2.onSubmit,
			    value = _props2.value;


			if (this.getError(value)) {
				this.setState({ showError: true });
			} else {
				onSubmit();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props3 = this.props,
			    value = _props3.value,
			    placeholder = _props3.placeholder,
			    label = _props3.label,
			    type = _props3.type,
			    disabled = _props3.disabled,
			    accept = _props3.accept,
			    alt = _props3.alt,
			    autoComplete = _props3.autoComplete,
			    autoFocus = _props3.autoFocus,
			    dirname = _props3.dirname,
			    form = _props3.form,
			    formAction = _props3.formAction,
			    formMethod = _props3.formMethod,
			    formNoValidate = _props3.formNoValidate,
			    formTarget = _props3.formTarget,
			    list = _props3.list,
			    max = _props3.max,
			    maxLength = _props3.maxLength,
			    min = _props3.min,
			    multiple = _props3.multiple,
			    name = _props3.name,
			    pattern = _props3.pattern,
			    readOnly = _props3.readOnly,
			    required = _props3.required,
			    size = _props3.size,
			    src = _props3.src,
			    step = _props3.step,
			    box = _props3.box,
			    updated = _props3.updated,
			    validator = _props3.validator,
			    tabIndex = _props3.tabIndex,
			    onMouseDown = _props3.onMouseDown,
			    renderLeftIcon = _props3.renderLeftIcon,
			    renderRightIcon = _props3.renderRightIcon;
			var showError = this.state.showError;


			return _react2.default.createElement(
				StyledInput,
				{
					isBox: box,
					isDisabled: disabled,
					hasValidator: !!validator,
					hasLabel: !!label },
				label ? _react2.default.createElement(
					'span',
					{ className: 'label' },
					label
				) : null,
				_react2.default.createElement(
					StyledInputWrapper,
					{
						box: box,
						error: showError,
						updated: updated,
						disabled: disabled },
					renderLeftIcon ? _react2.default.createElement(
						StyledLeftIcon,
						null,
						renderLeftIcon()
					) : null,
					_react2.default.createElement('input', {
						value: value,
						placeholder: placeholder,
						type: type,
						disabled: disabled,
						tabIndex: tabIndex,
						onMouseDown: onMouseDown,
						onChange: this.onChange,
						onFocus: this.onFocus,
						onBlur: this.onBlur,
						onKeyDown: function onKeyDown(e) {
							return e.keyCode == '13' ? _this2.onSubmit() : null;
						},
						accept: accept,
						alt: alt,
						autoComplete: autoComplete,
						autoFocus: autoFocus,
						dirname: dirname,
						form: form,
						formAction: formAction,
						formMethod: formMethod,
						formNoValidate: formNoValidate,
						formTarget: formTarget,
						list: list,
						max: max,
						maxLength: maxLength,
						min: min,
						multiple: multiple,
						name: name,
						pattern: pattern,
						readOnly: readOnly,
						required: required,
						size: size,
						src: src,
						step: step
					}),
					renderRightIcon ? _react2.default.createElement(
						StyledRightIcon,
						null,
						renderRightIcon()
					) : null
				),
				showError ? _react2.default.createElement(
					'span',
					{ className: 'error' },
					validator(value)
				) : null
			);
		}
	}]);

	return Input;
}(_react.Component);

Input.propTypes = {
	value: _propTypes2.default.string,
	placeholder: _propTypes2.default.string,
	label: _propTypes2.default.string,
	type: _propTypes2.default.string,
	tabIndex: _propTypes2.default.string,
	box: _propTypes2.default.bool,
	disabled: _propTypes2.default.bool,
	updated: _propTypes2.default.bool,
	accept: _propTypes2.default.string,
	alt: _propTypes2.default.string,
	autoComplete: _propTypes2.default.string,
	autoFocus: _propTypes2.default.string,
	dirname: _propTypes2.default.string,
	form: _propTypes2.default.string,
	formAction: _propTypes2.default.string,
	formMethod: _propTypes2.default.string,
	formNoValidate: _propTypes2.default.string,
	formTarget: _propTypes2.default.string,
	list: _propTypes2.default.string,
	max: _propTypes2.default.string,
	maxLength: _propTypes2.default.string,
	min: _propTypes2.default.string,
	multiple: _propTypes2.default.string,
	name: _propTypes2.default.string,
	pattern: _propTypes2.default.string,
	readOnly: _propTypes2.default.string,
	required: _propTypes2.default.string,
	size: _propTypes2.default.string,
	src: _propTypes2.default.string,
	step: _propTypes2.default.string,
	validator: _propTypes2.default.func,
	renderLeftIcon: _propTypes2.default.func,
	renderRightIcon: _propTypes2.default.func,
	onMouseDown: _propTypes2.default.func,
	onFocus: _propTypes2.default.func,
	onBlur: _propTypes2.default.func,
	onSubmit: _propTypes2.default.func,
	onChange: _propTypes2.default.func.isRequired
};
Input.defaultProps = {
	value: '',
	placeholder: '',
	label: '',
	type: 'text',
	box: false,
	disabled: false,
	updated: false,
	validator: null,
	renderLeftIcon: null,
	renderRightIcon: null,
	onFocus: function onFocus() {},
	onBlur: function onBlur() {},
	onSubmit: function onSubmit() {}
};
exports.Input = Input;